<template>
  <div class="comp-result"
    v-bind:class="dataId"
  >
    <v-container grid-list-md text-xs-center class="wrapper-container-relative">
      <v-layout row wrap class="max-height-container">
        <v-flex xl6 lg6 md6 sm12 xs12>
          <div class="bubble" ref="bubbleBox">
            <img class="arrow-bubble" v-bind:src="require('../../assets/images/lead-inter-asset-bubbleArrow.png')">

            <img class=""
              v-bind:src="require('../../assets/' + rank.imagePath)"
            >
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              class="title-style"
              v-bind:style="{color:themes.mainColor}"
            >
              {{rank.label}}
            </p>
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              class="result-text">
              {{rank.message}}
            </p>
            <div class="resp-wrap">
              <v-btn role="button" class="choices" round outline
                v-bind:style="{ borderColor: themes.mainColor }"
                @click="reloadPage"
              >
                Try Again
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xl6 lg6 md6 sm12 xs12>
          <div class="img-wrap">
            <img
              v-for="(character, index) in themes.characterPath"
              v-bind:key="index"
              v-bind:src="(content.data.imagePath !== '') ? require('../../assets/' + character) : ''"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState, mapMutations } from 'vuex'
import { focus } from 'vue-focus'

export default {
  name: 'ResultBoard',
  directives: {
    focus: focus,
    focusing: {
    // directive definition
      inserted: function (el, bind) {
        alert(bind.value)
        if (bind.value) {
          console.log(el)
          el.focus()
        }
      }
    }
  },
  data () {
    return {
      initFocus: false,
      enableTab: true,
      activeTabIndex: -1,
      hasAnswer: false,
      isCorrect: false
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    ...mapState({
      interactiveData: state => state.interactiveData,
      component: state => state.componentData
    }),
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    themes () {
      return this.$store.getters.getThemes(this.content.data.category)
    },
    info () {
      return this.$store.getters.getInfo()
    },
    rank () {
      this.setData()
      let score = this.content.data.currentScore
      let maxScore = this.content.data.maxScore
      let resultScore = 0
      let currentRank

      if (maxScore !== 0) {
        resultScore = (score * 100) / maxScore
      }

      for (let rankKey in this.content.data.ranks) {
        let rank = this.content.data.ranks[rankKey]
        let target = rank.targetScore
        if (resultScore >= target) {
          currentRank = rank
          break
        }
      }
      return currentRank
    }
  },
  created () {
    window.addEventListener('resize', () => {
      this.getAbsoluteTop()
    })
  },
  watch: {
    isActive () {
      if (this.isActive) {
        this.initFocus = true
        this.activeTabIndex = 1
      } else {
        this.activeTabIndex = -1
      }
    }
  },
  methods: {
    ...mapMutations([
      'goToSlide'
    ]),
    reloadPage () {
      this.$playSound(require('../../assets/audio/zapsplat_multimedia_click_003_19369.mp3'))
      location.reload()
    },
    setData () {
      let score = 0
      let maxScore = 0
      for (let index in this.interactiveData.scoreKeys) {
        let key = this.interactiveData.scoreKeys[index]
        let compObj = this.component[key]
        score = score + compObj.data.currentScore
        maxScore = maxScore + compObj.data.totalScore
      }
      this.content.data.currentScore = score
      this.content.data.maxScore = maxScore
    },
    resetTabIndex () {
      if (document.hasFocus()) {
        if (document.activeElement.getAttribute('islast') === 'true') {
          this.activeTabIndex = 1
        }
      }
    },
    getAbsoluteTop () {
      let elem = this.$refs.bubbleBox
      let topPos = $(elem).offset().top
      if (topPos !== 0) {
        this.info.absoluteTop = topPos
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/result-board/ResultBoard.vue